import { CaresIdsResolver } from '../resolvers/cares-ids/cares-ids.resolver';
import { ShelterIdResolver } from './../resolvers/shelter-id/shelter-id.resolver';
import { StandardLayoutComponent } from '../../shelter/layouts/standard-layout/standard-layout.component';
import { FullScreenLayoutComponent } from '../../shelter/layouts/full-screen-layout/full-screen-layout.component';
import { ShelterNameResolver } from './../resolvers/shelter-name/shelter-name.resolver';

export const shelterRoute = {
  path: 'shelter',
  url: '/shelter',
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: '/not-found',
    },
    {
      path: ':shelterId',
      children: [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'lists/attendance-list', // first default path
        },
        {
          path: 'lists',
          component: StandardLayoutComponent, // pass through
          loadChildren: () =>
            import('../../shelter/list/shelter-list-routing.module').then(m => m.ShelterListRoutingModule),
          resolve: {
            shelter: ShelterIdResolver,
            shelterName: ShelterNameResolver,
          },
        },
        {
          path: 'grid',
          component: FullScreenLayoutComponent, // pass through
          loadChildren: () =>
            import('../../shelter/grid/attendance/shelter-att-grid.module').then(m => m.ShelterAttGridModule),
        },
        {
          path: 'profile',
          component: FullScreenLayoutComponent, // pass through
          loadChildren: () => import('../../shelter/profile/shelter-profile.module').then(m => m.ShelterProfileModule),
          resolve: {
            caresIds: CaresIdsResolver,
          },
        },
      ],
    },
  ],
};
